const state = {
  form: {
    receiveAddrid: '',
    othderAddrid: '',
  },
}

const getters = {
}

const mutations = {
  initForm (state, form, rootState) {
    state.form = {
    }
  },
}

const actions = {
  createPreview ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/tb-dg/trade/order/create-preview', params, {
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  batchCreateOrder ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/tb-dg/trade/order/batch-create-order', params, {
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  batchPriceAdjust ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/tb-dg/order/notice/batch-price-adjust', params, {
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  priceAdjust ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/tb-dg/order/notice/price-adjust', params, {
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  search ({ state, commit, rootState }, params) {
    // return rootState.axios.get('/magicbuy/v1frontend/dgorder/search', { params })
    return rootState.axios.get('/magicbuy/dgorder/search', {
      params: {
        dgPlatform: 'TAOBAO',
        ...params
      },
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
